import {Select as AntdSelect} from 'antd';
import {useState} from 'react';
import ErrorText from '../ErrorText/errorText';

const {Option: AntdOption} = AntdSelect;

const CustomSelect = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = 'Select an option',
  required = false,
  name,
  error,
  multiple = false,
  useAntd = false,
  message,
}) => {
  const [open, setOpen] = useState(false);

  const handleAntdChange = (val) => {
    onChange(val);

    // 🔹 force close dropdown after selection
    setOpen(false);
  };

  return (
    <div>
      {label && (
        <label
          className="block font-medium mb-1 text-gray-700 text-left"
          htmlFor={name}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {useAntd ? (
        <>
          <AntdSelect
            mode={multiple ? 'multiple' : undefined}
            value={value}
            onChange={handleAntdChange}
            placeholder={placeholder}
            className="w-full"
            allowClear
            open={open}
            onDropdownVisibleChange={setOpen}
          >
            {options.map((opt) => (
              <AntdOption key={opt.value} value={opt.value}>
                {opt.label}
              </AntdOption>
            ))}
          </AntdSelect>

          {message && <ErrorText message={message} />}
        </>
      ) : (
        <>
          {/* ✅ YOUR ORIGINAL NATIVE SELECT (UNCHANGED) */}
          <select
            id={name}
            name={name}
            value={value}
            onChange={(e) =>
              multiple
                ? onChange(
                    Array.from(e.target.selectedOptions, (opt) => opt.value)
                  )
                : onChange(e.target.value)
            }
            required={required}
            multiple={multiple}
            className={`mt-1 block w-full px-3 py-[9px] border rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor ${
              error ? 'border-red-500' : 'border-gray-300'
            }`}
          >
            {!multiple && <option value="">{placeholder}</option>}
            {options.length > 0 ? (
              options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            ) : (
              <option disabled>No options available</option>
            )}
          </select>

          {message && <ErrorText message={message} />}
        </>
      )}
    </div>
  );
};

export default CustomSelect;
